import { type UserFilters } from '@app/services/user/manageUsersService';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface UsersState {
  filters?: UserFilters;
  pagination: {
    itemsPerPage: number;
    currentPage: number;
  };
}

const initialState: UsersState = {
  filters: {},
  pagination: {
    itemsPerPage: 10,
    currentPage: 1,
  },
};

export const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUserFilter: (state, action: PayloadAction<Partial<UsersState['filters']>>) => {
      if (action.payload) {
        state.filters = {
          ...state.filters,
          ...action.payload,
        };
      }
    },
    setUserPagination: (state, action: PayloadAction<Partial<UsersState['pagination']>>) => {
      state.pagination = {
        ...state.pagination,
        ...action.payload,
      };
    },
    resetUserFilter: (state, action: PayloadAction<keyof UserFilters>) => {
      const { [action.payload]: discardedValue, ...rest } = state.filters || {};
      state.filters = rest;
    },
  },
});

export const {
  setUserFilter,
  resetUserFilter,
  setUserPagination,
} = usersSlice.actions;

export default usersSlice.reducer;
